<template>
  <div class="ScrollBox">
    <van-nav-bar
      :border="false"
      left-arrow
      @click-left="$router.go(-1)"
      style="background:transparent;position:absolute;width:100%"
    />
    <div class="activity-top">
      <img :src="`./static/splashwater/${$i18n.locale}/title.png`" width="100%">
      <div class="activity-list">
        <div v-for="item,index in listData" :key="index" class="item">
          <a href="javascript:;" @click="(UserInfo.b_member<item.member||item.is_reward==1)?false:receiveReward(item.id,item.reward)">
            <img :src="`${InitData.setting.up_url}${item.cover_img}`" width="100%">
            <img :class="{'gray':UserInfo.b_member<item.member}" :src="`./static/splashwater/${$i18n.locale}/btn.png`" height="24">
          </a>
          <p>{{item.member}} USER</p>
          <span>{{item.reward}}THB</span>
        </div>
      </div>
      <div class="activity-gif">
        <img :src="`./static/splashwater/gif.png`" width="100%">
        <router-link class="btn" to="/user/promote">
          <img :src="`./static/splashwater/${$i18n.locale}/gif-btn2.png`" height="46">
        </router-link>
        <div class="hua">
          <img :src="`./static/splashwater/${$i18n.locale}/gif-btn1.png`" width="68">
          <div class="num">
            <b>{{UserInfo.b_member}}</b>
            <img :src="`./static/splashwater/hua.png`" width="100">
          </div>
        </div>
        <div class="pen">
          <img class="shui" :src="`./static/splashwater/shui.png`" width="58">
          <img :src="`./static/splashwater/pen.png`" width="100%">
        </div>
      </div>
    </div>
    <div class="activity-bottom">
      <img :src="`./static/splashwater/${$i18n.locale}/title-bottom.png`" width="100%">
      <ul class="list">
        <li v-for="item,index in listData" :key="'dec'+index">
          <div class="flex">
            <i>{{index+1}}</i>
            <div v-html="item.content"></div>
          </div>
        </li>
      </ul>
      <div class="explain">
        <div class="con" v-html="InitData.instruksiSongkran"></div>
        <img :src="`./static/splashwater/info.png`" width="35%">
      </div>
    </div>
    <van-dialog v-model="showDialog" :show-confirm-button="false" close-on-click-overlay style="background:transparent">
      <img v-if="currReward" :src="`./static/splashwater/${$i18n.locale}/d-${currReward}.png`" width="100%" />
      <a class="close" href="javascript:;" @click="showDialog=false"></a>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'SplashWater',
  components: {
  },
  props: [],
  data() {
    return {
      listData: '',
      showDialog: false,
      currReward: '',
    }
  },
  computed: {

  },
  watch: {

  },
  created() {
    this.$Model.GetUserInfo()
    this.getRewardlist()
  },
  mounted() {

  },
  activated() {

  },
  destroyed() {
    
  },
  methods: {
    receiveReward(id,reward) {
      this.currReward = reward
      this.$Model.ReceiveReward({id: id},data=>{
        if(data.code==1){
          this.showDialog = true
          this.getRewardlist()
        }
      })
    },
    getRewardlist() {
      this.$Model.GetRewardlist(data=>{
        this.listData = data.SongkranList
      })
    },
  }
}
</script>
<style scoped>
.van-nav-bar>>>.van-icon{
  color: var(--color-white);
}
img{
  display: block;
}
.activity-top{
  background: linear-gradient(#00b0c4,#e8ab35);
}
.activity-list{
  display: flex;
  padding: 10px 5px;
}
.activity-list .item{
  width: 25%;
  text-align: center;
  line-height: 1;
  color: #ec1785;
}
.activity-list .item>a{
  display: block;
}
.activity-list .item img{
  margin: 0 auto;
}
.activity-list .item img.gray{
  -webkit-filter: grayscale(100%);
  filter: grayscale(100%);
  filter: gray;
}
.activity-list .item p,.activity-list .item span{
  text-shadow: #fff 1px 0 0, #fff 0 1px 0, #fff -1px 0 0, #fff 0 -1px 0;
}
.activity-list .item span{
  font-size: 16px;
  font-weight: 600;
  margin-top: 3px;
  display: block;
}
.activity-gif{
  position: relative;
  margin-top: -55px;
}
.activity-gif .pen{
  position: absolute;
  bottom: 0;
  left: 60px;
  width: 50%;
}
.activity-gif .btn{
  position: absolute;
  left: 50%;
  bottom: 140px;
  transform: translateX(-50%);
}
.activity-gif .hua{
  position: absolute;
  right: 5px;
  bottom: 110px;
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}
.activity-gif .hua .num{
  position: relative;
  color: #ec1785;
  font-size: 24px;
}
.activity-gif .hua .num b{
  position: absolute;
  top: 15px;
  right: 30px;
}
.activity-gif .pen .shui{
  position: absolute;
  right: 50px;
  top: -10px;
  opacity: 0;
  animation: shui 1.2s linear infinite;
}
@keyframes shui {
  0% {
    transform: translate(0,0);
  }
  30% {
    opacity: 1;
  }
  80% {
    opacity: 1;
  }
  100% {
    opacity: 0;
    transform: translate(50px,-30px) rotate(60deg)
  }
}
.activity-bottom {
  background: linear-gradient(#30b2c9,#c1b561);
  overflow: hidden;
}
.activity-bottom .list{
  padding: 10px 50px;
}
.activity-bottom .list li{
  position: relative;
  margin: 15px 0;
  padding: 10px 0;
  line-height: 1;
}
.activity-bottom .list li:before{
  content: '';
  background-color: #bbd8d6;
  display: block;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
  border-radius: 10px;
}
.activity-bottom .list li:after{
  content: '';
  width: 100%;
  height: 50%;
  background-color: rgba(0, 0, 0, .2);
  position: absolute;
  bottom: -5px;
  border-radius: 0 0 10px 10px;
  z-index: 1;
}
.activity-bottom .list li .flex{
  display: flex;
  z-index: 3;
  position: relative;
  align-items: flex-start;
}
.activity-bottom .list li i{
  background: url('../../../public/static/splashwater/tag.png') no-repeat;
  background-size: auto 100%;
  padding: 3px 15px 3px 5px;
  color: #fff;
  text-align: center;
}
.activity-bottom .explain{
  background: linear-gradient(#54bca7,#e5ed6f);
  border-radius: 20px;
  box-shadow: 0 0 5px 5px rgba(255, 255, 255, .8);
  margin: 10px;
  padding: 13px;
  line-height: 1;
  position: relative;
}
.activity-bottom .explain .con{
  position: relative;
  z-index: 2;
}
.activity-bottom .explain .con>>>p:nth-last-child(1),
.activity-bottom .explain .con>>>p:nth-last-child(2),
.activity-bottom .explain .con>>>p:nth-last-child(3),
.activity-bottom .explain .con>>>p:nth-last-child(4){
  margin-right: 32%;
}
.activity-bottom .explain>img{
  position: absolute;
  right: -13px;
  bottom: -13px;
}
.van-dialog .close{
  position: absolute;
  top: 0;
  right: 0;
  width: 60px;
  height: 60px;
}
</style>